import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const isEn = i18n.language === "en";

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-white overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 text-[14rem] font-black text-stone-50 select-none pointer-events-none leading-none">
        404
      </div>
      <div className="relative z-10 max-w-md">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-amber-50 mx-auto mb-6">
          <i className="ri-error-warning-line text-amber-500 text-3xl" />
        </div>
        <h1 className="text-3xl font-bold text-stone-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
          {isEn ? "Page not found" : "Página no encontrada"}
        </h1>
        <p className="text-stone-500 text-sm mb-2 font-mono bg-stone-50 px-3 py-1.5 rounded-lg inline-block">
          {location.pathname}
        </p>
        <p className="text-stone-400 text-sm mt-3 mb-8">
          {isEn ? "The page you are looking for does not exist or has been moved." : "La página que buscas no existe o ha sido movida."}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-amber-500 hover:bg-amber-400 text-white font-semibold text-sm rounded-xl transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line" />
          {isEn ? "Back to home" : "Volver al inicio"}
        </Link>
      </div>
    </div>
  );
}
